import React from 'react'
import { asyncStacktrace, catchSyncStacktrace } from 'auto-trace'
import cancelable from 'react-disposable-decorator'
import { get } from 'lodash'
import { defer, pipe, from, concat } from 'rxjs'
import moment from 'moment'
// sofe imports
import { CprLoader, CprButton } from 'canopy-styleguide!sofe'
import Auth from 'cp-client-auth!sofe'
import canopyUrls from 'canopy-urls!sofe'
// project imports
import { checkMfaStatus } from './email-landing.resource.js'
import { doesTokenLookValid } from '../../utilities/checkToken.js'
import { showRememberPrompt } from 'src/utilities/togglePrompt.js'

@cancelable
export default class MFAEmailLanding extends React.Component {

  state = {
    badToken: false
  }

  componentDidMount() {
    const mfaToken = get(this.props, 'match.params.mfa_email_token')
    const softTokenCheck = doesTokenLookValid(mfaToken)
    this.nextCalled = 0
    if (softTokenCheck.maybeValid) {
      this.props.cancelWhenUnmounted(
        concat(
          checkMfaStatus(mfaToken),
          defer(Auth.refetchLoggedInUser),
          defer(Auth.refetchTenant),
        ).subscribe(
          this.successfulMFA,
          asyncStacktrace(err => {
            if (err.status === 403) {
              this.props.updateToken(mfaToken, () => {
                const geoInfo = 'data.body.geoInfo'
                const city = get(err, `${geoInfo}.city`)
                const state = get(err, `${geoInfo}.region_code`)
                const country = get(err, `${geoInfo}.country_code`)
                const location = `${city ? city : ''} ${state ? state : ''} ${country ? country : ''}`.trim()

                const deviceInfo = 'data.body.browser'
                const browser = get(err, `${deviceInfo}.agent`)
                const os = get(err, `${deviceInfo}.os`)
                const device = `${browser ? browser : ''} ${os ? 'on '+os : ''}`.trim()

                const utcTimestamp = get(err, 'data.body.timestamp')
                let time
                if(utcTimestamp) {
                  time = moment(utcTimestamp).format('MMMM Do, YYYY, h:mma')
                }
                const newDeviceInfo = {
                  location,
                  device,
                  time
                }
                this.props.updateDeviceInfo(newDeviceInfo, () => {
                  this.props.history.push(`/login/mfa/access-request`)
                })
              })
            } else if (err.status === 401 ) {
              this.setState({badToken: true})
            } else {
              catchSyncStacktrace(err)
              this.props.history.push('/')
            }
          })
        )
      )
    } else {
      this.setState({badToken: true})
    }
  }

  render () {
    if (this.state.badToken) {
      return (
        <div>
          <span className={`cps-subheader-sm`}>
            The authentication token is expired or invalid. Please try again or request a new link.
          </span>
          <div className={`cps-padding-bottom-16`} />
          <CprButton
            actionType={`primary`}
            type='button'
            onClick={this.routeToSignIn}
          >
            Return to sign in
          </CprButton>
        </div>
      )
    } else {
      return (<CprLoader />)
    }
  }

  successfulMFA = (results) => {
    this.nextCalled = this.nextCalled + 1
    if (results.instance_url) {
      this.instance_url = results.instance_url
    }
    if (this.nextCalled === 3) {
      if (!(this.instance_url && this.instance_url.includes('/authorize'))) {
        showRememberPrompt();
      }
      if (this.instance_url) {
        window.location.href = this.instance_url
      } else {
        this.props.history.push('/')
      }
    }

  }

  routeToSignIn = () => {
    this.props.history.push('/login')
  }
}
